module.exports = __webpack_public_path__ + "static/media/defile.b2cd8f51.jpg";